import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import BreadCrumb from '../utility/breadCrumb';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import Body from '../body/Nigel';
import Guru from '../components/GuitarGuruChat';
import Hero from '../hero/hero';

function Index() {
  return (
    <>
      <BreadCrumb 
        linkto="Nigel" 
        linkname="Nigel, the Guitar Guru" 
        linklevel="2" 
        linktoone="../portal" 
        linknameone="Student Portal"
        linktotwo="" 
        linknametwo="" 
      >
      </BreadCrumb>
      <Hero 
        paddingTop = "0px"
        id="7" 
        contentId="7"
        height="300" 
        gradient="true" 
        gradientDirection="to right" 
        gradientRgba="rgba(0,0,0,1) 76%, transparent" 
        backgroundSize="auto 100%" 
        backgroundRepeat="no-repeat" 
        backgroundColor="#000" 
        backgroundPosition="right"
        maxWidth="1400px"
        margin="auto"  >
      </Hero>
      <Body
       id="9"></Body>
      <div className="container" style={{marginTop: '30px', marginBottom: '50px'}}>
      <Guru></Guru>
      </div>
    </>
  );
}

export default Index;
